// extracted by mini-css-extract-plugin
module.exports = {"header":"Contact_header__HRNcx","button":"Contact_button__22V5y","label":"Contact_label__7qUw9","input":"Contact_input__2zzMR","textArea":"Contact_textArea__3_TTT"};